import _Image2 from "element-ui/lib/theme-chalk/image.css";
import "element-ui/lib/theme-chalk/base.css";
import _Image from "element-ui/lib/image";
import Vue from 'vue';
import App from './App.vue';
import './style/main.scss';
import { router } from './router';
import Loading from './directives/loading/loading';
import './iframeResizer.contentWindow.js';
Vue.config.productionTip = false;
Vue.directive('loading', Loading);
Vue.use(_Image);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');